import "./TaxResources.module.css";
import Header from "@/reusable_sections/Header";
import Knowledge from "./sections/Knowledge";
import TaxQuestions from "./sections/TaxQuestions";
import Informed from "./sections/Informed";
import Footer from "@/reusable_sections/Footer";
export default function TaxResourcesPage() {
  return <div>
      <Header />
      <Knowledge />
      <TaxQuestions />
      <Informed />
      <Footer />
    </div>;
}